<template>
    <div class="np-lazy-img" :key="$attrs.src">
        <b-img-lazy
            v-bind="$attrs"
            v-if="display"
            v-on="$listeners"
            :src="src"
            @error="onError"
        >
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
                <slot :name="slot" v-bind="scope" />
            </template>
        </b-img-lazy>
        <b-img-lazy
            v-bind="$attrs"
            v-else
            :src="fallback"
            v-on="$listeners"
            @error="onError"
        >
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
                <slot :name="slot" v-bind="scope" />
            </template>
        </b-img-lazy>
    </div>
</template>
<script>
import { BImgLazy } from 'bootstrap-vue';

export default {
    components: {
        BImgLazy,
    },
    props: {
        src: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            display: true,
            fallback: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICAgIGhlaWdodD0iMzAwcHgiIHdpZHRoPSIzMDBweCIKICAgICB2ZXJzaW9uPSIxLjEiCiAgICAgdmlld0JveD0iLTMwMCAtMzAwIDYwMCA2MDAiCiAgICAgZm9udC1mYW1pbHk9IkJpdHN0cmVhbSBWZXJhIFNhbnMsTGliZXJhdGlvbiBTYW5zLCBBcmlhbCwgc2Fucy1zZXJpZiIKICAgICBmb250LXNpemU9IjcyIgogICAgIHRleHQtYW5jaG9yPSJtaWRkbGUiID4KICAKICA8Y2lyY2xlIHN0cm9rZT0iI0FBQSIgc3Ryb2tlLXdpZHRoPSIxMCIgcj0iMjgwIiBmaWxsPSIjRkZGIi8+CiAgPHRleHQgc3R5bGU9ImZpbGw6IzQ0NDsiPgogICAgPHRzcGFuIHg9IjAiIHk9Ii04Ij5OTyBJTUFHRTwvdHNwYW4+PHRzcGFuIHg9IjAiIHk9IjgwIj5BVkFJTEFCTEU8L3RzcGFuPgogIDwvdGV4dD4KPC9zdmc+',
        };
    },
    methods: {
        onError() {
            this.display = false;
        },
    },
};
</script>
<style scoped>
::v-deep img {
    display: flex;
    max-width: 100%;
}
</style>
